import { t } from 'i18next';
// styles
import styles from './Conect.module.css';

const Conect = () => {
    return (
        <div className={styles['wrapper']}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                    d="M7.66667 12.6667H8.33333V11.4333L10.6667 9.1V6H5.33333V9.1L7.66667 11.4333V12.6667ZM6.33333 14V12L4 9.66667V6C4 5.63333 4.13056 5.31944 4.39167 5.05833C4.65278 4.79722 4.96667 4.66667 5.33333 4.66667H6L5.33333 5.33333V2H6.66667V4.66667H9.33333V2H10.6667V5.33333L10 4.66667H10.6667C11.0333 4.66667 11.3472 4.79722 11.6083 5.05833C11.8694 5.31944 12 5.63333 12 6V9.66667L9.66667 12V14H6.33333Z"
                    fill="#0171E6"
                />
            </svg>
            <p className={styles['text']}>{t('home.selectedPOS.home_selecterPointofsaleSecond')}</p>
        </div>
    );
};

export default Conect;
